import React from "react";

const Skills = () => {
  return (
    <section className="container">
      <div className="skills">
        <div className="skills__column">
          <h3 style={{ marginBottom: 45 }}>Design</h3>
          <svg
            id="Capa_1"
            viewBox="-30 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
          >
            <path
              d="m0 0 31.800781 448.101562 194.398438 63.898438 194.398437-63.898438 31.800782-448.101562zm0 0"
              fill="#ff7816"
            />
            <path
              d="m452.398438 0-31.800782 448.101562-194.398437 63.898438v-512zm0 0"
              fill="#ff4b00"
            />
            <path
              d="m367.5 136h-222.300781l5.398437 75h211.503906l-12.902343 181.597656-123 41.101563-123-41.101563-4.199219-60.597656h60l1.199219 16.5 66 21.898438 66-21.898438 5.398437-77.5h-203.097656l-13.800781-195h291zm0 0"
              fill="#ececf1"
            />
            <g fill="#e2e2e7">
              <path d="m362.101562 211-12.902343 181.597656-123 41.101563v-63.300781l66-21.898438 5.398437-77.5h-71.398437v-60zm0 0" />
              <path d="m371.699219 76-4.199219 60h-141.300781v-60zm0 0" />
            </g>
          </svg>
          <svg
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            width="50"
            height="50"
          >
            <polygon
              fill=" #2196F3"
              points="32,0 72.8,460.8 256,512 439.136,460.832 480,0 "
            />
            <polygon
              fill="#FAFAFA"
              points="392.768,150.688 387.616,208.576 372.064,382.112 256,414.208 255.904,414.24 
	139.904,382.112 131.808,291.36 188.64,291.36 192.864,338.432 255.936,355.456 255.968,355.424 319.136,338.4 327.744,259.968 
	129.088,260.512 123.456,206.88 332.512,204.416 336.736,147.008 117.856,147.616 114.176,94.208 256,94.208 397.824,94.208 "
            />
          </svg>
          <svg
            version="1.1"
            x="0px"
            y="0px"
            width="50"
            height="50"
            viewBox="0 0 512 512"
          >
            <path
              fill="#F2F2F2"
              d="M512,256c0,7.91-0.355,15.726-1.066,23.448c-0.543,6.113-1.317,12.152-2.299,18.119
	C488.782,419.182,383.227,512,256,512c-64.805,0-123.977-24.074-169.075-63.781c-16.666-14.66-31.41-31.462-43.802-49.977
	C15.882,357.564,0,308.632,0,256C0,114.615,114.615,0,256,0S512,114.615,512,256z"
            />
            <path
              fill="#CD6699"
              d="M446.767,284.975c-7.764,2.936-7.45,2.988-11.557-4.493c-5.245-9.529-8.035-19.55-8.276-30.448
	c-0.199-9.352,2.361-18.045,5.58-26.572c2.57-6.781-0.773-9.174-6.646-9.791c-4.274-0.439-8.683-0.397-12.967,0.042
	c-11.139,1.139-12.236,2.1-15.193,12.915c-1.755,6.416-3.156,12.884-6.071,18.975c-7.189,14.994-15.36,29.435-23.74,43.771
	c-1.505,2.581-2.748,5.36-4.869,7.565c-6.071-9.091-8.359-19.132-8.871-29.665c-0.512-10.397,2.675-20.062,6.175-29.623
	c1.181-3.218,0.199-5.214-2.581-6.604c-1.233-0.616-2.612-1.191-3.96-1.296c-7.147-0.564-14.273-0.481-21.243,1.473
	c-3.135,0.867-5.183,2.623-5.883,6.144c-1.358,6.886-3.479,13.573-6.343,20.01c-7.941,17.826-15.83,35.683-23.761,53.52
	c-6.896,15.496-13.688,31.033-21.859,45.913c-0.575,1.055-1.055,2.884-2.497,2.518c-1.463-0.366-0.951-2.163-1.014-3.396
	c-0.47-8.777,1.923-17.147,3.96-25.527c3.229-13.26,6.76-26.457,10.188-39.675c0.982-3.793-0.669-6.343-3.814-8.161
	c-4.524-2.602-9.028-2.727-13.928,0.919c0.669-5.392,0.961-10.125,0.731-14.858c-0.522-10.553-5.413-17.418-13.928-19.007
	c-6.217-1.16-12.1,0.648-17.659,3.281c-12.957,6.134-23.374,15.381-32.131,26.603c-1.024,1.306-2.058,2.508-3.542,3.312
	c-16.436,8.955-32.862,17.91-49.256,26.948c-1.797,1.003-2.957,0.721-4.253-0.669c-8.255-8.85-17.836-16.154-27.324-23.562
	c-13.26-10.365-26.979-20.187-38.421-32.684c-6.687-7.314-12.267-15.329-15.057-25.004c-4.556-15.82-1.149-30.553,6.437-44.554
	c8.976-16.562,22.288-29.351,36.968-40.741c23.312-18.077,48.88-32.434,75.828-44.251c30.177-13.218,61.482-21.734,94.824-20.449
	c13.208,0.512,26.028,2.8,37.794,9.268c8.328,4.577,13.845,11.191,15.402,20.898c1.829,11.368-0.899,21.87-5.945,31.828
	c-11.274,22.246-29.194,38.003-50.375,50.343c-17.638,10.271-36.665,16.792-56.801,20.208c-11.128,1.891-22.298,3.03-33.489,1.327
	c-12.842-1.954-24.712-6.248-33.499-16.593c-1.014-1.191-2.299-2.017-4.023-1.181c-1.766,0.857-1.63,2.424-1.463,3.929
	c0.125,1.034,0.408,2.079,0.773,3.062c2.351,6.343,6.75,11.128,11.901,15.308c13.396,10.898,29.268,14.096,45.934,14.42
	c16.311,0.324,32.371-1.745,48.264-5.548c35.85-8.568,65.881-26.154,87.803-56.289c13.103-18.014,21.4-37.867,20.668-60.583
	c-0.47-14.409-5.319-27.136-15.82-37.48c-12.487-12.278-27.982-18.453-44.607-22.162c-18.516-4.117-37.219-4.702-56.111-2.445
	c-16.436,1.964-32.496,5.329-48.128,10.71c-23.918,8.244-47.02,18.369-69.13,30.678c-22.653,12.601-44.001,27.032-62.725,45.108
	c-16.572,15.997-30.814,33.646-38.839,55.557c-3.427,9.383-5.893,19.028-3.594,29.174c2.947,13.061,9.383,24.367,17.847,34.565
	c12.8,15.444,28.505,27.606,44.701,39.225c13.009,9.341,26.624,17.847,39.121,27.888c3.542,2.842,3.521,2.842-0.648,5.026
	c-4.869,2.539-9.791,4.984-14.576,7.69C91.951,342.695,73.3,354.523,58.075,370.96c-7.492,8.098-12.581,17.189-14.952,27.282
	c12.392,18.516,27.136,35.318,43.802,49.977c28.432-2.215,50.197-17.011,66.278-41.482c7.764-11.818,11.4-25.192,12.769-39.299
	c1.202-12.434-0.063-24.472-3.72-36.342c-0.637-2.09-3.009-4.169-2.079-6.008c0.867-1.693,3.48-2.55,5.402-3.657
	c7.753-4.504,15.527-8.944,23.51-13.531c0.345,1.714-0.324,2.717-0.616,3.803c-4.577,16.792-7.764,33.719-4.284,51.169
	c2.163,10.867,5.768,21.096,12.622,30.093c7.053,9.258,22.8,8.202,29.194-0.251c6.071-8.025,10.094-17.074,14.284-26.081
	c2.299-4.932,4.409-9.947,6.604-14.932c-0.408,5.998-0.387,11.849-0.167,17.68c0.219,5.747,1.139,11.421,4.127,16.499
	c3.594,6.102,10.355,7.879,16.635,4.618c6.625-3.438,11.139-9.101,14.649-15.245c15.057-26.425,29.027-53.415,40.594-81.596
	c2.466-5.987,4.995-11.964,7.785-18.62c0.428,2.184,0.711,3.521,0.972,4.859c2.57,13.427,7.147,26.133,13.772,38.076
	c1.421,2.56,1.264,4.326-0.533,6.781c-6.102,8.307-12.79,16.123-19.383,24.022c-5.538,6.646-11.463,12.999-16.144,20.313
	c-4.2,6.583-1.787,13.322,5.204,14.817c2.152,0.46,4.42,0.596,6.625,0.564c12.215-0.146,23.489-3.793,33.991-9.77
	c14.137-8.056,22.518-19.864,22.131-36.676c-0.178-7.649-2.247-14.994-5.329-22.006c-0.679-1.557-0.711-2.685,0.303-4.148
	c9.791-14.023,18.442-28.724,26.394-43.854c1.411-2.664,2.403-5.622,4.681-8.223c0.303,1.055,0.543,1.714,0.679,2.393
	c2.529,12.539,5.935,24.795,12.33,35.986c1.755,3.062,0.878,4.618-1.546,6.666c-8.349,7.095-15.391,15.37-20.919,24.848
	c-4.305,7.377-7.252,15.255-7.22,23.897c0.031,9.613,7.387,15.276,16.76,13.019c9.77-2.341,18.829-6.322,26.958-12.267
	c17.711-12.967,22.904-26.645,17.356-45.735c-2.173-7.513-2.132-7.387,5.402-9.665c16.478-4.974,33.196-5.183,49.998-2.445
	c1.902,0.313,3.783,0.669,5.642,1.076c0.982-5.966,1.755-12.006,2.299-18.119C489.441,274.192,467.978,276.919,446.767,284.975z
	 M98.586,419.401c-4.775,1.693-9.738,2.414-14.817,2.017c-6.322-0.502-10.334-4.963-10.742-11.672
	c-0.46-7.732,1.829-14.712,5.214-21.504c6.154-12.33,16.488-20.699,27.032-28.912c10.25-7.993,21.264-14.817,32.402-21.452
	c3.375-2.006,3.427-1.985,4.2,2.038c1.003,5.162,1.902,10.334,1.567,15.026C144.321,383.08,123.883,410.446,98.586,419.401z
	 M251.956,277.514c-1.776,11.86-5.653,23.155-9.78,34.314c-5.622,15.235-11.097,30.542-18.171,45.192
	c-1.62,3.375-3.323,6.729-5.945,9.477c-2.476,2.602-4.671,2.299-6.384-0.878c-3.344-6.207-2.926-13.113-3.469-18.129
	c0.157-25.161,8.6-45.725,22.507-64.209c3.887-5.151,8.85-9.341,15.423-11.024C250.598,271.12,252.656,272.917,251.956,277.514z
	 M349.341,352.005c-4.765,8.234-11.63,14.221-20.052,18.484c-0.899,0.449-2.058,1.243-2.873,0.188
	c-0.773-0.993,0.47-1.651,1.034-2.278c8.37-9.143,16.635-18.359,24.085-28.275c0.115-0.157,0.397-0.178,1.034-0.449
	C352.496,344.263,351.493,348.296,349.341,352.005z M407.134,351.65c-1.243,0.585-2.685,1.682-3.897,0.742
	c-1.337-1.034-0.805-2.863-0.397-4.263c1.902-6.384,4.462-12.497,7.993-18.192c2.967-4.796,6.646-8.986,10.689-12.894
	c1.63-1.567,2.361-1.379,2.915,0.878c0.575,2.309,0.627,4.618,0.669,6.969C425.002,337.753,418.471,346.311,407.134,351.65z"
            />
          </svg>
          <p>I value simple content structure, clean design patterns.</p>
          <p className="skills__speaking">Languages I can speak:</p>
          <ul>
            <li>HTML</li>
            <li>CSS</li>
            <li>SCSS</li>
            <li>Bootstrap</li>
            <li>TailWindCSS</li>
            <li>Bulma</li>
          </ul>
        </div>
        <div className="skills__column">
          <h3>Code</h3>
          <svg viewBox="-28 0 480 480" width="60" heigh="60">
            <linearGradient
              id="a"
              gradientUnits="userSpaceOnUse"
              x1="212.205037"
              x2="212.205037"
              y1="476.432"
              y2="-26.208"
            >
              <stop offset="0" stopColor="#006df0" />
              <stop offset="1" stopColor="#00e7f0" />
            </linearGradient>
            <g fill="url(#a)">
              <path d="m212.203125 200c-22.089844 0-40 17.910156-40 40s17.910156 40 40 40c22.09375 0 40-17.910156 40-40-.023437-22.082031-17.917969-39.972656-40-40zm0 64c-13.253906 0-24-10.746094-24-24s10.746094-24 24-24c13.257813 0 24 10.746094 24 24s-10.742187 24-24 24zm0 0" />
              <path d="m351.40625 240c12.023438-10.164062 23.449219-21.015625 34.222656-32.496094 34.214844-37.007812 46.128906-67.273437 34.449219-87.503906-16.800781-29.0625-73.234375-23.671875-138.242187-.566406-12.519532-67.847656-36.078126-119.433594-69.632813-119.433594-33.550781 0-57.109375 51.585938-69.597656 119.441406-65.007813-23.105468-121.464844-28.496094-138.242188.558594-11.679687 20.230469.234375 50.496094 34.449219 87.503906 10.765625 11.480469 22.179688 22.328125 34.191406 32.496094-12.023437 10.164062-23.449218 21.015625-34.222656 32.496094-34.191406 37.007812-46.105469 67.273437-34.425781 87.503906 8 13.871094 25.050781 19.894531 47.753906 19.894531 31.011719-1.519531 61.574219-8.050781 90.496094-19.34375 12.488281 67.863281 36.046875 119.449219 69.597656 119.449219 33.554687 0 57.113281-51.585938 69.601563-119.441406 28.921874 11.285156 59.480468 17.816406 90.488281 19.335937 22.695312 0 39.742187-6.03125 47.753906-19.894531 11.679687-20.230469-.234375-50.496094-34.449219-87.503906-10.765625-11.480469-22.179687-22.328125-34.191406-32.496094zm54.816406-112c7.488282 12.976562-4.601562 38.640625-32.335937 68.640625-10.984375 11.6875-22.65625 22.703125-34.960938 32.992187-14.769531-11.878906-30.855469-23.65625-48.121093-35.066406-1.253907-20.253906-3.359376-40.207031-6.273438-59.199218 64.472656-23.144532 111.480469-24.96875 121.664062-7.367188zm-162.019531 167.425781c-10.847656 6.25-21.511719 12.066407-32 17.453125-10.472656-5.375-21.140625-11.195312-32-17.453125-10.710937-6.1875-21.046875-12.59375-31.117187-19.089843-.585938-11.726563-.882813-23.839844-.882813-36.335938s.296875-24.609375.882813-36.335938c10.070312-6.496093 20.40625-12.902343 31.117187-19.089843 10.839844-6.253907 21.507813-12.070313 32-17.445313 10.480469 5.390625 21.167969 11.199219 32 17.445313 10.714844 6.1875 21.050781 12.59375 31.121094 19.089843.585937 11.726563.878906 23.839844.878906 36.335938s-.292969 24.609375-.878906 36.335938c-10.070313 6.496093-20.40625 12.902343-31.121094 19.089843zm29.867187.710938c-1.167968 15.046875-2.785156 29.328125-4.800781 42.742187-12.625-4.984375-25.808593-10.726562-39.433593-17.246094 7.519531-4 14.992187-8.105468 22.34375-12.34375 7.351562-4.242187 14.738281-8.695312 21.890624-13.152343zm-79.519531 25.464843c-13.601562 6.511719-26.808593 12.261719-39.433593 17.246094-1.992188-13.414062-3.609376-27.695312-4.800782-42.742187 7.152344 4.453125 14.441406 8.835937 21.863282 13.152343 7.378906 4.269532 14.847656 8.34375 22.371093 12.34375zm-61.890625-56.21875c-12.175781-8.335937-23.671875-16.796874-34.496094-25.382812 10.796876-8.570312 22.292969-17.042969 34.496094-25.414062-.289062 8.476562-.457031 16.964843-.457031 25.414062s.167969 16.9375.457031 25.414062zm17.679688-81.550781c1.167968-15.039062 2.785156-29.3125 4.800781-42.71875 12.609375 4.976563 25.777344 10.726563 39.382813 17.230469-7.507813 3.988281-14.941407 8.101562-22.292969 12.335938-7.457031 4.320312-14.753907 8.714843-21.890625 13.183593zm79.539062-25.433593c13.597656-6.511719 26.796875-12.253907 39.414063-17.238282 1.992187 13.414063 3.609375 27.695313 4.800781 42.742188-7.167969-4.484375-14.464844-8.882813-21.890625-13.191406-7.34375-4.238282-14.804687-8.3125-22.324219-12.3125zm61.871094 56.226562c12.175781 8.328125 23.671875 16.789062 34.496094 25.375-10.796875 8.566406-22.292969 17.039062-34.496094 25.414062.285156-8.476562.453125-16.964843.453125-25.414062s-.167969-16.9375-.453125-25.414062zm-79.546875-198.625c20.363281 0 42.273437 41.65625 54.441406 109.078125-17.902343 6.96875-36.246093 15.128906-54.398437 24.179687-18.191406-9.050781-36.546875-17.210937-54.402344-24.179687 12.089844-67.414063 34-109.078125 54.359375-109.078125zm-161.652344 180.640625c-27.738281-30-39.824219-55.664063-32.335937-68.640625 4.519531-7.824219 16.277344-11.816406 33.597656-11.816406 30.207031 1.589844 59.957031 8.074218 88.089844 19.199218-2.914063 18.960938-5.015625 38.90625-6.273438 59.152344-17.265625 11.410156-33.351562 23.199219-48.121094 35.066406-12.300781-10.277343-23.976562-21.285156-34.957031-32.960937zm-32.335937 155.359375c-7.488282-12.976562 4.597656-38.640625 32.335937-68.640625 10.980469-11.6875 22.652344-22.703125 34.957031-32.992187 14.769532 11.878906 30.855469 23.65625 48.121094 35.066406 1.257813 20.253906 3.359375 40.207031 6.273438 59.199218-64.496094 23.144532-111.503906 24.96875-121.6875 7.367188zm193.988281 112c-20.359375 0-42.261719-41.65625-54.398437-109.070312 17.894531-6.96875 36.25-15.128907 54.441406-24.175782 18.191406 9.046875 36.542968 17.207032 54.4375 24.175782-12.214844 67.414062-34.117188 109.070312-54.480469 109.070312zm193.992187-112c-10.175781 17.601562-57.214843 15.777344-121.6875-7.390625 2.914063-18.96875 5.015626-38.921875 6.273438-59.203125 17.265625-11.40625 33.351562-23.199219 48.121094-35.0625 12.304687 10.285156 23.976562 21.304688 34.957031 32.992188 27.738281 30.023437 39.824219 55.6875 32.335937 68.664062zm0 0" />
            </g>
          </svg>
          <svg
            id="Lager_1"
            version="1.1"
            viewBox="0 5 128 100"
            width="70"
            height="70"
          >
            <g>
              <g>
                <g>
                  <circle cx="64" cy="64" r="50" fill="#F0DB4F" />
                </g>
              </g>
              <g id="Layer_1_1_">
                <g>
                  <g>
                    <path
                      d="M48.4,44.6h8.7v24.5c0,11-5.3,14.9-13.7,14.9c-2.1,0-4.7-0.3-6.4-0.9l1-7.1      c1.2,0.4,2.8,0.7,4.5,0.7c3.7,0,6-1.7,6-7.6L48.4,44.6L48.4,44.6z"
                      fill="#323330"
                    />
                    <path
                      d="M64.8,74.4c2.3,1.2,6,2.4,9.7,2.4c4,0,6.1-1.7,6.1-4.3c0-2.4-1.8-3.8-6.5-5.4      c-6.4-2.3-10.7-5.9-10.7-11.6C63.4,49,69,44,78.1,44c4.4,0,7.6,0.9,9.9,2l-2,7c-1.5-0.7-4.3-1.8-8-1.8c-3.8,0-5.6,1.8-5.6,3.7      c0,2.5,2.1,3.6,7.2,5.5c6.8,2.5,10,6.1,10,11.6c0,6.5-4.9,12-15.6,12c-4.4,0-8.8-1.2-11-2.4L64.8,74.4z"
                      fill="#323330"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <svg height="60" version="1.1" viewBox="0 0 512 512" width="60">
            <g id="_x32_67-python">
              <g>
                <path
                  d="M194.005,240.252h105.054c29.216,0,52.529-24.101,52.529-53.414V86.603    c0-28.525-24.002-49.871-52.529-54.691c-35.214-5.804-73.478-5.509-105.054,0.097c-44.462,7.87-52.527,24.298-52.527,54.693    v21.453H246.63v31.959H102.033c-30.591,0-57.349,18.394-65.709,53.315c-9.64,40.035-10.033,65.02,0,106.826    c7.476,31.085,25.28,53.314,55.872,53.314h36.101v-48.001C128.296,270.845,158.298,240.252,194.005,240.252L194.005,240.252z"
                  fill="#347AB4"
                />
                <path
                  d="M474.975,209.372c-7.575-30.395-21.935-53.315-52.527-53.315h-39.443v46.626    c0,36.199-30.692,66.691-65.71,66.691H212.24c-28.724,0-52.528,24.594-52.528,53.414v100.138    c0,28.524,24.788,45.246,52.528,53.413c33.247,9.737,65.215,11.509,105.054,0c26.462-7.675,52.529-23.116,52.529-53.413v-20.997    H264.867v-32.417h157.58c30.593,0,41.904-21.346,52.527-53.314C485.992,283.244,485.501,251.57,474.975,209.372L474.975,209.372z"
                  fill="#FFCA1D"
                />
                <path
                  d="M187.415,89.594c-10.479,0-18.975-8.591-18.975-19.164c0.094-10.668,8.496-19.259,18.975-19.259    c10.385,0,18.976,8.685,18.976,19.259C206.39,81.003,197.894,89.594,187.415,89.594z"
                  fill="#FFFFFF"
                />
                <path
                  d="M314.908,460.076c-10.479,0-18.976-8.591-18.976-19.164c0.095-10.668,8.496-19.259,18.976-19.259    c10.385,0,18.976,8.685,18.976,19.259C333.884,451.485,325.388,460.076,314.908,460.076z"
                  fill="#FFFFFF;"
                />
              </g>
            </g>
            <g id="Layer_1" />
          </svg>
          <p>
            My main development languages are ReactJs and JavaScript, but I have
            worked with Python, NodeJS, Java and more..
          </p>
          <p className="skills__speaking">Languages I can speak:</p>
          <ul>
            <li>Javascript</li>
            <li>ReactJS</li>
            <li>NodeJS</li>
            <li>ExpressJS</li>
            <li>jQuery</li>
            <li>Python</li>
          </ul>
        </div>
        <div className="skills__column">
          <h3>Tools</h3>
          <svg
            id="Capa_1"
            version="1.1"
            viewBox="0 0 24 24"
            width="65"
            height="60"
          >
            <g>
              <path
                d="M23.5615234,10.9320221c-0.0009766,0-0.0009766-0.0004883-0.0009766-0.0004883L13.0615234,0.4256744   c-0.5664063-0.567749-1.5576172-0.5672607-2.1220703-0.0004883L0.4384766,10.9320221C0.15625,11.2158966,0,11.5926056,0,11.9927521   c0,0.4006348,0.15625,0.777771,0.4394531,1.0611572l10.4990234,10.5058594   C11.2216797,23.8436432,11.5986328,24.0000153,12,24.0000153s0.7783203-0.1563721,1.0605469-0.4397583l10.5-10.5063477   C23.84375,12.7705231,24,12.3933868,24,11.9927521C24,11.5926056,23.84375,11.2158966,23.5615234,10.9320221z"
                fill="#EF473B"
              />
              <path
                d="M23.6809692,12.6898956l-10.609375,10.6157837   C12.786438,23.5919952,12.4055176,23.7500153,12,23.7500153s-0.786438-0.15802-1.0725708-0.4448242L0.3190308,12.6898956   c-0.1239624-0.1240845-0.218689-0.2683716-0.2921143-0.4222412c0.0545654,0.2959595,0.1953125,0.5689087,0.4125366,0.7862549   l10.4990234,10.5058594C11.2216797,23.8436432,11.5986328,24.0000153,12,24.0000153s0.7783203-0.1563721,1.0605469-0.4397583   l10.5-10.5063477c0.2172241-0.2173462,0.3580322-0.4902954,0.4125977-0.7862549   C23.8997192,12.421524,23.8049316,12.5658112,23.6809692,12.6898956z"
                fill="#010101"
                opacity="0.1"
              />
              <path
                d="M17,10.0000153c-0.3748779,0-0.7219849,0.1100464-1.0222168,0.2902832l-2.2680664-2.2680664   C13.8898926,7.7220612,14,7.3749542,14,7.0000153c0-1.1030273-0.8974609-2-2-2   c-0.369873,0-0.7122803,0.1077881-1.0098267,0.2835693L8.536438,2.8295441L7.8295898,3.5367584l2.4536743,2.4539795   C10.1077271,6.2881012,10,6.6303253,10,7.0000153c0,0.9293213,0.6400146,1.7053833,1.5,1.9289551v6.1420898   C10.6400146,15.294632,10,16.070694,10,17.0000153c0,1.1030273,0.8974609,2,2,2s2-0.8969727,2-2   c0-0.9293213-0.6400146-1.7053833-1.5-1.9289551V8.9289703c0.1767578-0.0459595,0.3425293-0.1158447,0.4968872-0.2055054   l2.2796631,2.2796631C15.1053467,11.2978058,15,11.6353302,15,12.0000153c0,1.1030273,0.8974609,2,2,2s2-0.8969727,2-2   S18.1025391,10.0000153,17,10.0000153z"
                fill="#FFFFFF"
              />
              <path
                d="M0.4384766,11.1820221L10.9394531,0.6751862   c0.5644531-0.5667725,1.5556641-0.5672607,2.1220703,0.0004883l10.4990234,10.5058594c0,0,0,0.0004883,0.0009766,0.0004883   c0.2523193,0.2537842,0.3969727,0.583252,0.4262695,0.935791C23.991272,12.075943,24,12.0352325,24,11.9927521   c0-0.4001465-0.15625-0.7768555-0.4384766-1.06073c-0.0009766,0-0.0009766-0.0004883-0.0009766-0.0004883L13.0615234,0.4256744   c-0.5664063-0.567749-1.5576172-0.5672607-2.1220703-0.0004883L0.4384766,10.9320221C0.15625,11.2158966,0,11.5926056,0,11.9927521   c0,0.0424194,0.008728,0.0831299,0.012207,0.124939C0.0415649,11.765152,0.1862183,11.4357452,0.4384766,11.1820221z"
                fill="#FFFFFF"
                opacity="0.2"
              />
              <linearGradient
                gradientUnits="userSpaceOnUse"
                id="SVGID_1_"
                x1="9.6692657"
                x2="18.3065948"
                y1="9.6760864"
                y2="18.3134155"
              >
                <stop offset="0" stopColor="#010101" stopOpacity="0.1" />
                <stop offset="1" stopColor="#010101" stopOpacity="0" />
              </linearGradient>
              <path
                d="M18.5488281,10.7503815C18.8265381,11.0938263,19,11.5248566,19,12.0000153   c0,1.1030273-0.8974609,2-2,2s-2-0.8969727-2-2c0-0.3646851,0.1053467-0.7022095,0.2765503-0.9968872L12.9968872,8.723465   C12.8425293,8.8131256,12.6767578,8.8830109,12.5,8.9289703v6.1420898c0.8599854,0.2235718,1.5,0.9996338,1.5,1.9289551   c0,1.1030273-0.8974609,2-2,2c-0.5114746,0-0.9738159-0.1986694-1.3278809-0.5157471l3.7318115,3.7318115l7.8029175-7.8076782   L18.5488281,10.7503815z M13.7097168,8.0222321l2.2680664,2.2680664C16.2780151,10.1100616,16.6251221,10.0000153,17,10.0000153   c0.4750977,0,0.90625,0.1735229,1.2498169,0.451355l-4.6776733-4.6777344L13.5697021,5.77565   C13.835144,6.1150665,14,6.5366364,14,7.0000153C14,7.3749542,13.8898926,7.7220612,13.7097168,8.0222321z"
                fill="url(#SVGID_1_)"
              />
              <linearGradient
                gradientUnits="userSpaceOnUse"
                id="SVGID_2_"
                x1="2.0138185"
                x2="21.983366"
                y1="7.3399205"
                y2="16.6518726"
              >
                <stop offset="0" stopColor="#FFFFFF" stopOpacity="0.2" />
                <stop offset="1" stopColor="#FFFFFF" stopOpacity="0" />
              </linearGradient>
              <path
                d="M23.5615234,10.9320221c-0.0009766,0-0.0009766-0.0004883-0.0009766-0.0004883L13.0615234,0.4256744   c-0.5664063-0.567749-1.5576172-0.5672607-2.1220703-0.0004883L0.4384766,10.9320221C0.15625,11.2158966,0,11.5926056,0,11.9927521   c0,0.4006348,0.15625,0.777771,0.4394531,1.0611572l10.4990234,10.5058594   C11.2216797,23.8436432,11.5986328,24.0000153,12,24.0000153s0.7783203-0.1563721,1.0605469-0.4397583l10.5-10.5063477   C23.84375,12.7705231,24,12.3933868,24,11.9927521C24,11.5926056,23.84375,11.2158966,23.5615234,10.9320221z"
                fill="url(#SVGID_2_)"
              />
            </g>
          </svg>
          <svg
            role="img"
            viewBox="0 0 24 24"
            width="70"
            height="70"
            id="Capa_1"
          >
            <title />
            <path d="M0 7.334v8h6.666v1.332H12v-1.332h12v-8H0zm6.666 6.664H5.334v-4H3.999v4H1.335V8.667h5.331v5.331zm4 0v1.336H8.001V8.667h5.334v5.332h-2.669v-.001zm12.001 0h-1.33v-4h-1.336v4h-1.335v-4h-1.33v4h-2.671V8.667h8.002v5.331zM10.665 10H12v2.667h-1.335V10z" />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            width="70px"
            height="70px"
          >
            <polygon fill="#ace3ff" points="7,17 32,3 58,17 32,31" />
            <polygon fill="#ace3ff" points="6,17 6,47 32,62 32,31" />
            <polygon fill="#7bbeeb" points="17,23 32,15 47,23 32,31" />
            <polygon fill="#ace3ff" points="32,62 59,47 59,17 32,31" />
            <polygon fill="#7bbeeb" points="17,23 17,41 32,49 32,31" />
            <polygon fill="#7bbeeb" points="32,49 47,41 47,23 32,31" />
            <polygon fill="#e3f2ff" points="17,41 6,47 6,17 17,23" />
            <path
              fill="#8d6c9f"
              d="M32,32c-0.162,0-0.324-0.039-0.471-0.117l-15-8C16.204,23.709,16,23.369,16,23 s0.204-0.709,0.529-0.883l15-8c0.294-0.156,0.647-0.156,0.941,0l15,8C47.796,22.291,48,22.631,48,23s-0.204,0.709-0.529,0.883 l-15,8C32.324,31.961,32.162,32,32,32z M19.125,23L32,29.866L44.875,23L32,16.134L19.125,23z"
            />
            <path
              fill="#8d6c9f"
              d="M17,27c-0.552,0-1-0.447-1-1v-2.406L5.521,17.878C5.199,17.702,4.999,17.364,5,16.997 c0.001-0.366,0.203-0.703,0.526-0.878l26-14c0.487-0.262,1.093-0.08,1.354,0.407c0.262,0.485,0.08,1.092-0.406,1.354 L8.099,17.006l9.38,5.116C17.8,22.297,18,22.634,18,23v3C18,26.553,17.552,27,17,27z"
            />
            <path
              fill="#8d6c9f"
              d="M17,35c-0.552,0-1-0.447-1-1v-4c0-0.553,0.448-1,1-1s1,0.447,1,1v4C18,34.553,17.552,35,17,35z"
            />
            <path
              fill="#8d6c9f"
              d="M32,50c-0.162,0-0.323-0.039-0.471-0.117l-15-8C16.204,41.709,16,41.369,16,41v-3 c0-0.553,0.448-1,1-1s1,0.447,1,1v2.4l13,6.933V31c0-0.553,0.448-1,1-1s1,0.447,1,1v18c0,0.352-0.184,0.677-0.485,0.857 C32.356,49.952,32.178,50,32,50z"
            />
            <polygon fill="#85cbf8" points="59,47 32,61 32,49 47,41" />
            <path
              fill="#8d6c9f"
              d="M32,63c-0.175,0-0.351-0.046-0.507-0.138C31.187,62.683,31,62.354,31,62V49c0-0.553,0.448-1,1-1 s1,0.447,1,1v11.301l25.514-14.175c0.484-0.27,1.092-0.094,1.36,0.389c0.269,0.482,0.094,1.091-0.388,1.359l-27,15 C32.334,62.958,32.167,63,32,63z"
            />
            <path
              fill="#8d6c9f"
              d="M47,42c-0.552,0-1-0.447-1-1V23c0-0.379,0.214-0.725,0.553-0.895l10.244-5.122L33,4.645V15 c0,0.553-0.448,1-1,1s-1-0.447-1-1V3c0-0.35,0.182-0.673,0.48-0.854c0.298-0.182,0.67-0.194,0.98-0.033l27,14 c0.334,0.173,0.542,0.519,0.54,0.896c-0.003,0.376-0.216,0.719-0.553,0.887L48,23.618V41C48,41.553,47.552,42,47,42z"
            />
            <path
              fill="#8d6c9f"
              d="M44.139,44.66c-0.357,0-0.703-0.192-0.883-0.529l-0.941-1.765 c-0.261-0.487-0.076-1.093,0.411-1.353c0.49-0.261,1.093-0.075,1.353,0.411l0.941,1.765c0.261,0.487,0.076,1.093-0.411,1.353 C44.458,44.622,44.297,44.66,44.139,44.66z"
            />
            <path
              fill="#8d6c9f"
              d="M39.972,46.883c-0.357,0-0.703-0.192-0.884-0.529l-0.941-1.766 c-0.26-0.487-0.075-1.094,0.412-1.354c0.489-0.259,1.093-0.074,1.354,0.412l0.941,1.766c0.26,0.487,0.075,1.094-0.412,1.354 C40.291,46.845,40.13,46.883,39.972,46.883z"
            />
            <path
              fill="#8d6c9f"
              d="M35.805,49.104c-0.357,0-0.703-0.192-0.883-0.529l-0.942-1.765 c-0.26-0.487-0.076-1.093,0.412-1.353c0.49-0.261,1.094-0.075,1.353,0.411l0.941,1.765c0.261,0.487,0.076,1.093-0.411,1.353 C36.124,49.066,35.963,49.104,35.805,49.104z"
            />
            <path
              fill="#8d6c9f"
              d="M59,48c-0.153,0-0.306-0.035-0.447-0.105l-12-6c-0.494-0.247-0.694-0.848-0.447-1.342 c0.247-0.493,0.847-0.692,1.342-0.447L58,45.382V17c0-0.553,0.448-1,1-1s1,0.447,1,1v30c0,0.347-0.18,0.668-0.474,0.851 C59.365,47.95,59.183,48,59,48z"
            />
            <g>
              <path
                fill="#8d6c9f"
                d="M6,48c-0.177,0-0.354-0.047-0.51-0.14C5.186,47.68,5,47.353,5,47V17c0-0.553,0.448-1,1-1 s1,0.447,1,1v28.315l9.521-5.193c0.487-0.264,1.093-0.085,1.357,0.399c0.265,0.484,0.086,1.092-0.399,1.356l-11,6 C6.33,47.959,6.165,48,6,48z"
              />
            </g>
            <g>
              <path
                fill="#8d6c9f"
                d="M31.999,63c-0.169,0-0.341-0.043-0.499-0.134l-26-15C5.022,47.59,4.858,46.979,5.134,46.5 c0.276-0.478,0.887-0.643,1.366-0.366l26,15c0.479,0.276,0.643,0.888,0.367,1.366C32.681,62.82,32.345,63,31.999,63z"
              />
            </g>
          </svg>
          <p>I use countless tools while developing applications!</p>
          <p className="skills__speaking">Some Tools I can use:</p>
          <ul>
            <li>Git</li>
            <li>Github</li>
            <li>Npm</li>
            <li>Gulp</li>
            <li>Webpack</li>
            <li>Jira</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Skills;
